export default __webpack_public_path__ + "static/media/ph-logo.05f35356.png";